import React from 'react';
import { Radio } from 'antd';
import { RadioGroupProps } from 'antd/lib/radio';
import styles from './index.module.less';

interface CategoryItem {
  value: string;
  title: string;
  description: string;
}

interface CategoryRadioProps extends Omit<RadioGroupProps, 'options'> {
  options?: CategoryItem[];
}

const CategoryRadio: React.FC<CategoryRadioProps> = ({
  options = [],
  ...rest
}) => (
  <Radio.Group {...rest}>
    {options.map(({ value, title, description }) => (
      <Radio className={styles.radio} key={value} value={value}>
        <div className={styles.item}>
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>{description}</div>
        </div>
      </Radio>
    ))}
  </Radio.Group>
);

export default CategoryRadio;
